/**
 * Cross-filtered variant availability for Focal's <product-variants> component.
 *
 * Focal's stock `_updateDisableSelectors` (assets/theme.js) is one-directional:
 * option 1 is checked against the whole variant list, option 2 is filtered by the
 * selected option 1, option 3 by options 1 + 2. Because of that the first picker
 * (e.g. size) never reacts to the second picker (e.g. color), so sold-out
 * combinations stay un-struck after a color is chosen.
 *
 * This override replaces the availability check with a symmetric one: every option
 * value is checked against ALL other currently selected option values.
 *
 * What is intentionally NOT changed: the "does this combination exist at all"
 * check that drives the `hidden` attribute keeps Focal's original cascade, so no
 * swatch starts appearing/disappearing that did not do so before.
 *
 * Loaded globally from layout/theme.liquid because quick-buy popovers inject their
 * markup via innerHTML, where a local <script src> tag would never execute.
 */
(function () {
  if (window.themeVariantAvailabilityPatched) return;
  window.themeVariantAvailabilityPatched = true;

  // Mirrors the selectors Focal uses per data-selector-type.
  var ITEM_SELECTORS = {
    color: '.color-swatch',
    'variant-image': '.variant-swatch',
    block: '.block-swatch',
    dropdown: '.combo-box__option-item',
  };

  customElements.whenDefined('product-variants').then(function () {
    var prototype = customElements.get('product-variants').prototype;

    prototype._updateDisableSelectors = function () {
      var selectedVariant = this.selectedVariant;

      if (!selectedVariant || !this.product || !this.optionSelectors) return;

      var variants = this.product['variants'];
      var selectedValues = selectedVariant['options'];
      var hideSoldOut = this.hideSoldOutVariants;

      this.product['options'].forEach(function (option, optionIndex) {
        var selector = this.optionSelectors[optionIndex];

        if (!selector) return;

        var itemSelector = ITEM_SELECTORS[selector.getAttribute('data-selector-type')];

        if (!itemSelector) return;

        option['values'].forEach(function (value, valueIndex) {
          var item = selector.querySelector(itemSelector + ':nth-child(' + (valueIndex + 1) + ')');

          if (!item) return;

          // Existence — Focal's original cascade: only options BEFORE this one constrain it.
          var exists = variants.some(function (variant) {
            return (
              variant['options'][optionIndex] === value &&
              variant['options'].every(function (variantValue, index) {
                return index >= optionIndex || variantValue === selectedValues[index];
              })
            );
          });

          // Availability — cross-filtered: every OTHER selected option constrains it.
          var available = variants.some(function (variant) {
            return (
              variant['available'] &&
              variant['options'][optionIndex] === value &&
              variant['options'].every(function (variantValue, index) {
                return index === optionIndex || variantValue === selectedValues[index];
              })
            );
          });

          item.toggleAttribute('hidden', !exists);

          if (hideSoldOut) {
            item.toggleAttribute('hidden', !available);
          } else {
            item.classList.toggle('is-disabled', !available);
          }
        });
      }, this);
    };

    // Any instance that already finished loading its product data was painted with
    // the original logic — repaint it once.
    document.querySelectorAll('product-variants').forEach(function (element) {
      if (element.product) element._updateDisableSelectors();
    });
  });
})();
